<template>
    <div class="alarm-statiscs-wrap">
        <el-form
            :model="searchForm"
            class="leader-style-form"
            ref="searchForm"
            :rules="searchFormRule"
            :inline="true"
        >
            <el-form-item label="日期" prop="date">
                <el-date-picker
                    v-model="searchForm.date"
                    type="date"
                    placeholder="请选择日期"
                    :default-value="searchForm.date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    @change="yymmdd"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="采集点" prop="point_id">
                <el-select v-model="searchForm.point_id">
                    <el-option
                        v-for="item in points"
                        :label="item.point_name"
                        :key="item.point_id"
                        :value="item.point_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报警类型">
                <el-select v-model="searchForm.warn_type" clearable>
                    <el-option
                        v-for="item in warn_types"
                        :label="item.code_name"
                        :key="item.code_value"
                        :value="item.code_value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报警级别">
                <el-select v-model="searchForm.warn_level" clearable>
                    <el-option
                        v-for="item in warn_levels"
                        :label="item.code_name"
                        :key="item.code_value"
                        :value="item.code_value"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-button @click="clear" class="leader-common-button" style="float: right; ">清空</el-button>
            <el-button
                class="leader-common-button"
                @click="search"
                style="float: right; margin-right: 10px; "
            >查询</el-button>
        </el-form>

        <div class="table-wrap">
            <el-table border :data="tableList" class="leader-style-table">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="采集点" align="center" prop="point_name"></el-table-column>
                <el-table-column label="日期" align="center" prop="cur_time"></el-table-column>
                <el-table-column label="报警值" align="center" prop="alarm_value"></el-table-column>
                <el-table-column label="标准值" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.low_warn }} ~
                            {{ scope.row.hight_warn }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="类型名称" align="center" prop="warn_type_name"></el-table-column>
                <el-table-column label="报警级别" align="center" prop="warn_level_name">
                    <template slot-scope="scope">
                        <span
                            v-if="scope.row.warn_level == '10'"
                            style="color: #ba0000"
                        >{{ scope.row.warn_level_name }}</span>
                        <span v-else style="color: #107300">
                            {{
                                scope.row.warn_level_name
                            }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { getSysDate, getCodelistByKind } from "@/http/api";
import * as api from "@/http/hr";

export default {
    data() {
        return {
            loading: false, //loading状态
            points: [],
            warn_types: [],
            warn_levels: [],
            searchForm: {
                date: "", //日期
                point_id: "", //采集点
                warn_type: "", //报警类型
                warn_level: "" //参数值
            },
            searchFormRule: {
                date: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ]
                // point_id: [
                //     {
                //         required: true,
                //         message: '采集点不能为空',
                //         trigger: 'change',
                //     },
                // ],
            },
            tableList: []
        };
    },
    created() {
        this.getSysDate();
        this.getSelectPoint();
        this.getWarnType("warn_type");
        this.getWarnLevel("warn_level");
    },
    methods: {
        // 获取系统时间
        getSysDate() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.date = res.bus_json.sysdate;
                    this.search();
                }
            });
        },
        // 获得采集点集合
        getSelectPoint() {
            api.getSelectPoint().then(res => {
                if (res && res.error_code === "0") {
                    let resData = res.bus_json;
                    this.points = resData.filter(item => item.state == "0");
                }
            });
        },
        // 获取报警类型
        getWarnType(type) {
            getCodelistByKind({ code_kind: type }).then(res => {
                if (res && res.error_code === "0") {
                    this.warn_types = res.bus_json[0].codelists;
                }
            });
        },
        // 获取报警参数
        getWarnLevel(type) {
            getCodelistByKind({ code_kind: type }).then(res => {
                if (res && res.error_code === "0") {
                    this.warn_levels = res.bus_json[0].codelists;
                }
            });
        },
        search() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    api.getAlarmList({
                        point_id: this.searchForm.point_id,
                        date: this.searchForm.date,
                        warn_type: this.searchForm.warn_type,
                        warn_level: this.searchForm.warn_level,
                        pageNum: 1,
                        pageSize: 99999
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.tableList = res.bus_json.items;
                        }
                        this.loading = false;
                    });
                }
            });
        },
        clear() {
            this.searchForm.date = "";
            this.searchForm.point_id = "";
            this.searchForm.warn_level = "";
            this.searchForm.warn_type = "";
        }
    }
};
</script>
<style lang="scss">
.alarm-statiscs-wrap {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: px2Rem(20px);
}
</style>
